import { render, staticRenderFns } from "./schoolNumsAdd.vue?vue&type=template&id=27077276&"
import script from "./schoolNumsAdd.vue?vue&type=script&lang=js&"
export * from "./schoolNumsAdd.vue?vue&type=script&lang=js&"
import style0 from "./schoolNumsAdd.vue?vue&type=style&index=0&id=27077276&prod&lang=less&scpoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports